export const PAGE_HEADER_BACK_BUTTON_TEST_ID = 'page-header-back-button';
export const PAGE_HEADER_ERROR_HEADER_TEST_ID = 'page-header-error-header';
export const PAGE_HEADER_INCOMPATIBILITY_ERROR_HEADER_TEST_ID = 'page-header-incompatibility-error-header';
export const PAGE_HEADER_SUCCESS_HEADER_TEST_ID = 'page-header-success-header';
export const PAGE_HEADER_LOADING_HEADER_TEST_ID = 'page-header-loading-header';

export const CENSUS_TABLE_TEST_ID = 'census-table';
export const CENSUS_TABLE_ROW_TEST_ID = 'census-table-row';
export const CENSUS_TABLE_HEADER_TEST_ID = 'census-table-header';
export const CENSUS_TABLE_CELL_TEST_ID = 'census-table-cell';
export const CENSUS_TABLE_TOGGLE_TEST_ID = 'census-table-toggle';

export const CENSUS_STATISTICS_REDO_BUTTON_TEST_ID = 'census-statistics-redo-button';
export const CENSUS_STATISTICS_SUBMIT_BUTTON_TEST_ID = 'census-statistics-submit-button';
export const INCOMPATIBILITY_ERROR_TEST_ID = 'incompatibility-error';
export const INCOMPATIBILITY_ERROR_REUPLOAD_BUTTON_TEST_ID = 'incompatibility-error-reupload-button';

export const CENSUS_STATISTICS_BLOCK_TEST_ID = 'census-statistics-block';
export const CENSUS_STATISTICS_TOTAL_CARD_TEST_ID = 'census-statistics-total-imports-card';
export const CENSUS_STATISTICS_EMPLOYEES_CARD_TEST_ID = 'census-statistics-employees-imported-card';
export const CENSUS_STATISTICS_DEPENDENTS_CARD_TEST_ID = 'census-statistics-dependents-imported-card';
export const CENSUS_STATISTICS_ERRORS_CARD_TEST_ID = 'census-statistics-import-errors-card';
export const CENSUS_STATISTICS_ERROR_DISCLAIMER_TEST_ID = 'census-statistics-error-disclaimer';
export const CENSUS_STATISTICS_LOADER_TEST_ID = 'census-statistics-loader-test-id';
